import {
  createElement,
  type ComponentProps,
  type ComponentType,
  type ElementType,
} from 'react';

import {
  getCommerceBillingUiPorts,
  type CommerceBillingUiPorts,
} from './billing-ui-ports';

type PortComponentKey = {
  [K in keyof CommerceBillingUiPorts]: CommerceBillingUiPorts[K] extends ElementType
    ? K
    : never;
}[keyof CommerceBillingUiPorts];

/** A component member of the boot ports, resolved lazily at render time. */
export const portComponent = <K extends PortComponentKey>(key: K) => {
  type P = Extract<ComponentProps<CommerceBillingUiPorts[K]>, object>;
  const PortComponent = (props: P) => {
    const Component = getCommerceBillingUiPorts()[key] as ComponentType<P>;
    return createElement(Component, props);
  };
  PortComponent.displayName = `PortComponent(${key})`;
  return PortComponent;
};
